import type { PContainer } from '../engine/aliases'
import { assert } from '../lib/assert-sidecar'
import { common } from '../main/common-sidecar'
import { echoFonts } from '../proto/echo/echoFonts-sidecar'

import type { IStevieText2 } from '../uiParts/stevieTexts2'
import { stevieTexts2 } from '../uiParts/stevieTexts2-sidecar'

interface IData {
  isOpen: boolean
  textFps: IStevieText2
}
let _data: IData | null = null
export const getData = () => {
  assert.notNil(_data)
  return _data
}

export const create = (layer: PContainer) => {
  let text = stevieTexts2.create(
    echoFonts.getData().font6, //ctx.font16,
    700,
    500,
    layer,
  )
  stevieTexts2.setText(text, 'FPS')
  stevieTexts2.setScale(text, 3)

  _data = {
    isOpen: false,
    textFps: text,
  }
  setOpen(true)
}

export const setOpen = (isOpen: boolean, isSemiOpen: boolean = false) => {
  let data = getData()
  data.isOpen = isOpen

  stevieTexts2.setVisible(data.textFps, isOpen && !isSemiOpen)
}

export const update = (gb: { width: number; height: number }) => {
  let s = common.getPhaserScene()

  let data = getData()
  if (data && data.isOpen) {
    let fps = Math.round(s.game.loop.actualFps)
    if (fps === 59 || fps === 61) {
      fps = 60
    }

    stevieTexts2.setText(data.textFps, '' + fps)
    // stevieTexts.moveTo(data.textFps, 1, window.innerHeight - 20)
    // let b = underCamera.getGameBounds()
    stevieTexts2.moveTo(data.textFps, gb.width - 20, gb.height - 12)
  }
}
